<template>
    <div class="quotation full-width">
        <Spinner v-bind:title="'Sending Quotation Please Wait...'" v-if="sendingQuotation" class="full-window-spinner"></Spinner>
        <div v-if="sendingQuotation === false">
            <br>
            <div class="col-xs-12">

                <div class="alert-info alert" v-if="workerInterventionDataRaw!==null">
                    {{ workerInterventionDataRaw.quote.private_note}}
                </div>

                <h4>{{'Write your quotation here, we will put it to clean'|trans}}</h4>
            </div>
            <div class="col-xs-12 clear-both">
                <Pictures
                        v-bind:jobid="job.id"
                        v-bind:documentID="quote.id"
                        v-bind:tagPicture="'devis'"
                        v-on:picturesSelected="picturesSelected"
                >
                </Pictures>
            </div>
            <br>
            <div class="col-xs-12">
                <h4>{{'Items of quote'|trans}}</h4>
                <div v-show="quote.document_items.length <= 0" class="alert alert-danger">
                    {{'One item is mandatory'|trans}}
                </div>

                <template v-for="(item, index) in quote.document_items">

                    <table class="table table-info table-item "  v-bind:class="{'alert-empty':!isItemEmpty(item)}">

                        <tbody>
                        <tr>
                            <td colspan="4">
                                <div class="fieldOuter">
                                    <input type="text" class="form-control full-width" v-bind:placeholder="'Title'|trans" v-model="item.title" v-bind:id="_uid">
                                    <label v-bind:for="_uid" >{{'Title'|trans}}</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td width="50%" >
                                <div class="fieldOuter">
                                    <CurrencyInput   v-model.number="item.price" class="form-control" v-bind:placeholder="'Price unit'|trans" v-bind:id="_uid"></CurrencyInput>
                                    <label v-bind:for="_uid">{{'Price unit'|trans}}</label>
                                </div>
                            </td>
                            <td width="30%">
                                <div class="fieldOuter">
                                    <input type="number" v-bind:id="'qtt'" class="form-control" v-model.number="item.quantity" v-bind:placeholder="'qtt'|trans" >
                                    <label v-bind:for="'qtt'">{{'Quantity'|trans}}</label>
                                </div>
                            </td>
                            <td width="20%" class="text-center total-price-item" valign="middle"><strong>
                                {{ item.price * item.quantity }}{{ $currency.symbol(user.country)}}
                            </strong></td>
                            <td width="10%">
                                <button class="btn btn-danger" @click="removeItem(index)"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </template>

                <table class="table-item table table-info">
                    <tbody>
                    <tr>
                        <td colspan="4">
                            <strong>{{'Total HT'|trans}} : {{ totalPriceOfItems }} {{ $currency.symbol(user.country)}} </strong>
                        </td>
                        <td></td>
                        <td>
                            <button class="btn btn-primary full-width" @click="addItem()">
                                {{'Add new item'|trans}}
                                <span class="fa fa-plus-circle"></span>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="form-group">
                    <label>{{'Email'|trans}}</label>
                    <div class=" alert alert-danger" v-if="!validateEmail(quote.job.customer.email)">
                        {{'Please enter a valid address'|trans}}
                    </div>
                    <input type="email" class="form-control " placeholder="Email client"
                           v-model="quote.job.customer.email"
                    />
                </div>

            </div>
            <div class="col-xs-12">
                <strong>{{'Private Note'|trans}}</strong>
                <br>

                <div class="private_note" v-show="quote.private_note !== '' " ref="scrollText">
                    <div v-html="prettyLog(quote.private_note)"> </div>
                </div>

                <textarea v-model="quote.empty_private_note" class="form-control" rows="2" ></textarea>

            </div>
            <div class="col-xs-12">
                <div class="form-group ">

                    <div v-show="quote.id !== undefined"  class="row">
                        <div class="col-xs-12" v-if="job.isPureContact">
                            <button class="small-btn-close-input btn-primary btn full-width"
                                    v-on:click="updateQuotation('client')"
                                    v-bind:disabled="!createQuotationIsValid"
                            >
                                {{'Send to client'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12" v-if="!job.isPureContact">
                            <button class="small-btn-close-input btn-primary btn full-width"
                                    v-on:click="updateQuotation('account')"
                                    v-bind:disabled="!createQuotationIsValid"
                            >
                                <nl2br tag="span" :text="'Send to account'|trans"/>
                            </button>
                        </div>
                    </div>

                    <br>
                    <div v-show="quote.id === undefined"  class="row">
                        <div class="col-xs-12" v-if="job.isPureContact">
                            <button class="small-btn-close-input btn-primary btn full-width"
                                    v-on:click="createQuotation('client')"
                                    v-bind:disabled="!createQuotationIsValid"
                            >
                                {{'Send to client'|trans}}
                            </button>
                        </div>

                        <div class="col-xs-12" v-if="job.isWorkerTheOwner === true && job.isPureContact === false">
                            <button class="small-btn-close-input btn-primary btn full-width"
                                    v-on:click="createQuotation('account')" v-show="quote.id === undefined"
                                    v-bind:disabled="!createQuotationIsValid"
                            >
                                    <nl2br tag="span" :text="'Send to account'|trans"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CurrencyInput from './CurrencyInput';
    import Pictures from './Pictures';
    import Spinner from './Spinner';

    export default {
        props: {
            quote: null,
            job: Object,
            user:null
        },
        data() {
            return {
                workerInterventionDataRaw: null,
                sendingQuotation: false,
                item: {
                    title: null,
                    price: null,
                    quantity: 1,
                    total: 0
                }
            }
        },
        created() {
            if(this.job.is_pure_contact!==undefined){ // patch not proud of this
                this.job.isPureContact = this.job.is_pure_contact;
            }
            if(this.quote.private_note === undefined){
                this.quote.private_note = "";
            }
            if(this.quote.job.worker_intervention !== undefined){
                if(this.quote.job.worker_intervention !== null){
                    this.workerInterventionDataRaw = JSON.parse(this.quote.job.worker_intervention.data_raw);
                }
            }
            this.isRealEmail();
        },
        mounted(){
            let objDiv = this.$refs.scrollText;
            if( objDiv !== undefined ){
                objDiv.scrollTop = objDiv.scrollHeight;
            }
        },
        computed: {
            createQuotationIsValid() {

                const has_items = !(this.quote.document_items.length <= 0);

                const document_items_are_valids = this.quote.document_items.every(function (item) {
                    return item.price !== null && item.title !== null;
                });

                if (
                    !this.quote.job.customer.email
                    || !this.validateEmail(this.quote.job.customer.email)
                    || !document_items_are_valids
                    || !has_items
                    //|| (this.quote.empty_private_note.length < 15)
                ) {
                    return false;
                }
                return true;
            },
            totalPriceOfItems(){

                if(this.quote.document_items){
                    return this.quote.document_items.reduce(
                        function (accumulator, item) {
                            return accumulator + (item.price * item.quantity);
                        },
                        0
                    );
                }else{
                    return 0;
                }

            },
            isPrivateNoteValid(){
                return this.quote.empty_private_note.length > 15
            }
        },
        methods: {
            tooltip(message){
                console.log(message);
            },
            isItemEmpty(item){
                return item.price !== null && item.title !== null;
            },
            picturesSelected(pictures){
                this.quote.picturesSelected = pictures;
            },
            addItem() {
                this.quote.document_items.push(Object.assign({}, this.item));
            },
            removeItem(index) {
                this.quote.document_items.splice(index, 1);
            },
            validateEmail(email) {
                if (email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                } else {
                    return true;
                }
            },
            prettyLog(str){

                const regex = /(\[.*?\])(\[.*?\])/gm;

                let m;

                let tmpStr = str;

                while ((m = regex.exec(str)) !== null) {
                    // This is necessary to avoid infinite loops with zero-width matches
                    if (m.index === regex.lastIndex) {
                        regex.lastIndex++;
                    }

                    // The result can be accessed through the `m`-variable.
                    m.forEach((match, groupIndex) => {
                        if(groupIndex === 0){
                            tmpStr = tmpStr.replace(match, "<hr>\n <p class='log_private_note'>"+match+"</p>");
                        }
                    });
                }

                return tmpStr;
            },
            async updateQuotation(finalRecipient) {
                if(navigator.onLine){
                    this.confirmQuitQuote();
                    this.sendingQuotation = true;
                    this.quote.finalRecipient = finalRecipient;
                    await this.$api.quotation.updateQuotation(this.quote.id, this.quote);
                    this.sendingQuotation = false;
                    this.$emit('quoteDone');
                    this.removeListenerConfirmQuitQuote();
                } else {
                    alert('Not internet connection try later');
                }
            },
            async createQuotation(finalRecipient){
                this.confirmQuitQuote();
                if(navigator.onLine){
                    this.sendingQuotation = true;
                    this.quote.finalRecipient = finalRecipient;
                    let response = await this.$api.quotation.createQuotation(this.job.id, this.quote);
                    this.sendingQuotation = false;
                    if(response.is_email_sent){
                      this.$emit('quoteDone');
                      this.removeListenerConfirmQuitQuote();
                    }else{
                      alert('Email not valid');
                    }
                } else {
                    alert('Not internet connection try later');
                }
            },
            isRealEmail() {
                const regex = /^no.{0,5}@|^.{0,2}@/i;
                let m;
                if ((m = regex.exec(this.quote.job.customer.email)) !== null) {
                    m.forEach((match, groupIndex) => {
                        this.quote.job.customer.email = "";
                    });
                }
            },
            confirm(e){
                    e.preventDefault();
                    e.returnValue = '';
            },
            confirmQuitQuote(){
                window.addEventListener('beforeunload',this.confirm);
            },
            removeListenerConfirmQuitQuote(){
                window.removeEventListener("beforeunload",this.confirm);
            }
        },
        components: {
            CurrencyInput,
            Pictures,
            Spinner
        }
    }

</script>

<style scoped>

    .quotation{
        background-color: #f9f9f9;
        padding-bottom:10px;
        display: inline-block;
    }

    .quotation .table-item{
        background: #f9f9f9;
        border-bottom:4px solid #e0e0e0;
        padding-bottom: 0px;
    }

    .quotation .table-item td{
        vertical-align: middle;
        padding:4px;
    }
    .quotation .table-item td > btn btn-danger{
        padding: 0px;
    }

    .quotation .private_note{
        max-height: 100px;
        overflow-y: scroll;
        background: #eef9da;
        padding:8px;
    }

    .quotation .total-price-item{
        font-size:14px;
    }

    .quotation h4{
        margin-top:5px;
        margin-bottom:5px;
    }

    .quotation .alert-empty{
        background-color: #ffb8aa;
        border-color: #fb927d;
        color: #7c1a06;
    }

    .fieldOuter {
        position: relative;
    }

    .fieldOuter label {
        position: absolute;
        right:0;
        top: 0;
        line-height:15px;
        transition: all 0.2s;
        overflow: hidden;
        color: #999;
        white-space: nowrap;
        z-index: 1;
        opacity: 0;
        height: 0px;
    }
    .fieldOuter input:focus + label {
        opacity: 1;
        top: -21px;
        height: auto;
        background: #202020;
        padding: 3px 11px;
        border-radius: 2px;
        color: white;
    }
    .fieldOuter input:focus {
        outline: none;
        border-color: rgba(131, 236, 44, 0.8);
    }

    .full-window-spinner{
        position: fixed !important;
        height: 100%;
        width: 100%;
        top: 0px;
        padding-top:46px;
        left:0px;
        z-index: 999999 !important;
        background: #fafbff;
        display: inline-table;
    }



</style>

<style>

    .private_note hr{
        margin:0px;
    }
    .private_note .log_private_note{
        color: #38a3de;
        font-style: italic;
        font-size: 11px;
        font-family: Verdana;
        margin: 3px 0px;
    }
</style>
